// extracted by mini-css-extract-plugin
export default {"item":"SignCode_item__Q1O27","icon":"SignCode_icon__ommrF","content":"SignCode_content__Kcyov","button":"SignCode_button__Eckgp"};